import { render, staticRenderFns } from "./MobileBottom.vue?vue&type=template&id=6fbe1158&scoped=true"
import script from "./MobileBottom.vue?vue&type=script&lang=js"
export * from "./MobileBottom.vue?vue&type=script&lang=js"
import style0 from "./MobileBottom.vue?vue&type=style&index=0&id=6fbe1158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe1158",
  null
  
)

export default component.exports